import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Layout/Header';
import Footer from '../components/Layout/Footer';

export default function Privacy() {
  const [siteLang, setSiteLang] = useState('FR');
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#fff', fontFamily: 'Arial, sans-serif', display: 'flex', flexDirection: 'column' }}>
      <Header siteLang={siteLang} setSiteLang={setSiteLang} />

      <section style={{ backgroundColor: '#0e0e0e', padding: '60px 24px', textAlign: 'center' }}>
        <p style={{ color: '#FF0066', fontSize: '11px', letterSpacing: '5px', margin: '0 0 12px', fontWeight: '700' }}>COMPIFY</p>
        <h1 style={{ color: '#fff', fontSize: '36px', fontWeight: '900', letterSpacing: '2px', margin: 0, textTransform: 'uppercase' }}>
          {siteLang === 'FR' ? 'POLITIQUE DE CONFIDENTIALITÉ' : 'PRIVACY POLICY'}
        </h1>
        <p style={{ color: '#555', fontSize: '12px', margin: '16px 0 0', letterSpacing: '1px' }}>
          {siteLang === 'FR' ? 'Dernière mise à jour : mars 2026' : 'Last updated: March 2026'}
        </p>
      </section>

      <section style={{ padding: '80px 24px', flex: 1 }}>
        <div style={{ maxWidth: '720px', margin: '0 auto' }}>

          {[
            {
              title: siteLang === 'FR' ? '1. Responsable du traitement' : '1. Data controller',
              content: siteLang === 'FR'
                ? 'Le responsable du traitement des données est Compify, accessible à l\'adresse compify.fr. Pour toute question relative à vos données personnelles, contactez-nous via le formulaire de contact.'
                : 'The data controller is Compify, accessible at compify.fr. For any questions regarding your personal data, contact us via the contact form.'
            },
            {
              title: siteLang === 'FR' ? '2. Données collectées' : '2. Data collected',
              content: siteLang === 'FR'
                ? 'Compify collecte un minimum de données. Vos photos sont traitées localement dans votre navigateur et ne sont jamais transmises à nos serveurs. Les informations saisies dans l\'éditeur (nom, mensurations, etc.) restent sur votre appareil. Nous collectons uniquement des données de navigation anonymisées à des fins statistiques.'
                : 'Compify collects minimal data. Your photos are processed locally in your browser and are never transmitted to our servers. Information entered in the editor (name, measurements, etc.) stays on your device. We only collect anonymized browsing data for statistical purposes.'
            },
            {
              title: siteLang === 'FR' ? '3. Cookies' : '3. Cookies',
              content: siteLang === 'FR'
                ? 'Compify utilise des cookies techniques nécessaires au bon fonctionnement du service. Des cookies publicitaires peuvent être déposés par nos partenaires annonceurs. Vous pouvez gérer vos préférences cookies à tout moment depuis les paramètres de votre navigateur.'
                : 'Compify uses technical cookies necessary for the service to function. Advertising cookies may be placed by our advertising partners. You can manage your cookie preferences at any time from your browser settings.'
            },
            {
              title: siteLang === 'FR' ? '4. Publicité ciblée' : '4. Targeted advertising',
              content: siteLang === 'FR'
                ? 'Compify est financé par la publicité ciblée. Nos partenaires publicitaires peuvent utiliser des données de navigation anonymisées pour afficher des publicités pertinentes. Ces données ne permettent pas de vous identifier personnellement.'
                : 'Compify is funded by targeted advertising. Our advertising partners may use anonymized browsing data to display relevant ads. This data does not allow you to be personally identified.'
            },
            {
              title: siteLang === 'FR' ? '5. Partage des données' : '5. Data sharing',
              content: siteLang === 'FR'
                ? 'Compify ne vend pas vos données personnelles à des tiers. Les données de navigation anonymisées peuvent être partagées avec nos partenaires publicitaires dans le respect du RGPD.'
                : 'Compify does not sell your personal data to third parties. Anonymized browsing data may be shared with our advertising partners in compliance with GDPR.'
            },
            {
              title: siteLang === 'FR' ? '6. Vos droits' : '6. Your rights',
              content: siteLang === 'FR'
                ? 'Conformément au RGPD, vous disposez d\'un droit d\'accès, de rectification, de suppression et de portabilité de vos données. Pour exercer ces droits, contactez-nous via le formulaire de contact. Nous nous engageons à répondre dans un délai de 30 jours.'
                : 'In accordance with GDPR, you have the right to access, rectify, delete and port your data. To exercise these rights, contact us via the contact form. We commit to responding within 30 days.'
            },
            {
              title: siteLang === 'FR' ? '7. Sécurité' : '7. Security',
              content: siteLang === 'FR'
                ? 'Compify met en place des mesures techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé, modification, divulgation ou destruction.'
                : 'Compify implements appropriate technical and organizational measures to protect your data against unauthorized access, modification, disclosure or destruction.'
            },
            {
              title: siteLang === 'FR' ? '8. Modifications' : '8. Changes',
              content: siteLang === 'FR'
                ? 'Compify se réserve le droit de modifier la présente politique de confidentialité à tout moment. Les modifications entrent en vigueur dès leur publication sur cette page. Nous vous encourageons à consulter régulièrement cette page.'
                : 'Compify reserves the right to modify this privacy policy at any time. Changes take effect upon publication on this page. We encourage you to check this page regularly.'
            },
          ].map((section, i) => (
            <div key={i} style={{ marginBottom: '40px', paddingBottom: '40px', borderBottom: i < 7 ? '1px solid #f0f0f0' : 'none' }}>
              <h2 style={{ color: '#1A1A1A', fontSize: '16px', fontWeight: '700', margin: '0 0 14px', letterSpacing: '0.5px' }}>{section.title}</h2>
              <p style={{ color: '#666', fontSize: '14px', lineHeight: 1.8, margin: 0 }}>{section.content}</p>
            </div>
          ))}

          <div style={{ marginTop: '48px', padding: '24px', backgroundColor: '#f7f7f7', textAlign: 'center' }}>
            <p style={{ color: '#888', fontSize: '13px', margin: '0 0 16px' }}>
              {siteLang === 'FR' ? 'Des questions sur vos données ?' : 'Questions about your data?'}
            </p>
            <button onClick={() => navigate('/contact')} style={{
              backgroundColor: '#FF0066', color: '#fff', border: 'none',
              padding: '12px 28px', fontSize: '11px', letterSpacing: '2px',
              fontWeight: '700', cursor: 'pointer'
            }}>
              {siteLang === 'FR' ? 'NOUS CONTACTER' : 'CONTACT US'}
            </button>
          </div>
        </div>
      </section>

      <Footer siteLang={siteLang} />
    </div>
  );
}